export const products = [
  {
    id: 1,
    name: "Romantic Rose Bouquet",
    nameF: "Bouquet de Roses Romantiques",
    category: "flowers",
    price: 15000,
    originalPrice: 18000,
    image: "https://readdy.ai/api/search-image?query=romantic%20red%20rose%20bouquet%20elegantly%20arranged%20with%20baby%20breath%20flowers%20on%20soft%20cream%20background%2C%20luxury%20gift%20shop%20presentation%2C%20warm%20golden%20light%2C%20premium%20floral%20arrangement%2C%20beautiful%20and%20lush&width=400&height=400&seq=p1&orientation=squarish",
    description: "A stunning arrangement of fresh red roses, perfect for expressing love and admiration.",
    descriptionF: "Un magnifique arrangement de roses rouges fraîches, parfait pour exprimer l'amour.",
    badge: "popular",
    rating: 4.9,
    reviews: 124,
  },
  {
    id: 2,
    name: "Lavender Dreams Candle",
    nameF: "Bougie Rêves de Lavande",
    category: "candles",
    price: 8500,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=elegant%20scented%20lavender%20candle%20in%20glass%20jar%20with%20gold%20lid%20on%20cream%20marble%20surface%2C%20luxury%20home%20decor%2C%20soft%20warm%20ambient%20light%2C%20premium%20gift%20presentation%2C%20beautiful%20minimalist&width=400&height=400&seq=p2&orientation=squarish",
    description: "Hand-poured lavender and vanilla scented candle with 40+ hours burn time.",
    descriptionF: "Bougie parfumée à la lavande et vanille coulée à la main, plus de 40h de combustion.",
    badge: "new",
    rating: 4.8,
    reviews: 89,
  },
  {
    id: 3,
    name: "Mango Homemade Jelly",
    nameF: "Gelée Maison à la Mangue",
    category: "jellies",
    price: 4500,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=artisan%20homemade%20mango%20jelly%20in%20beautiful%20glass%20jar%20with%20golden%20lid%20and%20ribbon%2C%20warm%20cream%20background%2C%20gourmet%20food%20photography%2C%20premium%20gift%20presentation%2C%20tropical%20fruit%20preserve&width=400&height=400&seq=p3&orientation=squarish",
    description: "Artisan mango jelly made from fresh Cameroonian mangoes. Rich, sweet, and irresistible.",
    descriptionF: "Gelée de mangue artisanale faite à partir de mangues fraîches du Cameroun.",
    badge: "popular",
    rating: 4.7,
    reviews: 203,
  },
  {
    id: 4,
    name: "Luxury Gift Hamper",
    nameF: "Panier Cadeau Luxueux",
    category: "giftboxes",
    price: 45000,
    originalPrice: 55000,
    image: "https://readdy.ai/api/search-image?query=luxury%20gift%20hamper%20basket%20filled%20with%20flowers%20candles%20books%20and%20gourmet%20treats%20wrapped%20in%20gold%20ribbon%20on%20cream%20background%2C%20premium%20boutique%20gift%20presentation%2C%20elegant%20and%20beautiful&width=400&height=400&seq=p4&orientation=squarish",
    description: "A curated luxury hamper with flowers, candles, jellies, and gourmet treats.",
    descriptionF: "Un panier luxueux avec fleurs, bougies, gelées et gourmandises.",
    badge: "sale",
    rating: 5.0,
    reviews: 67,
  },
  {
    id: 5,
    name: "Inspirational Journal Set",
    nameF: "Ensemble Journal Inspirant",
    category: "books",
    price: 12000,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=beautiful%20leather%20bound%20inspirational%20journal%20and%20pen%20set%20on%20cream%20background%20with%20dried%20flowers%2C%20elegant%20stationery%20gift%2C%20warm%20golden%20tones%2C%20premium%20book%20gift%20presentation&width=400&height=400&seq=p5&orientation=squarish",
    description: "Premium leather-bound journal with gold pen, perfect for dreamers and writers.",
    descriptionF: "Journal en cuir premium avec stylo doré, parfait pour les rêveurs et écrivains.",
    badge: "new",
    rating: 4.6,
    reviews: 45,
  },
  {
    id: 6,
    name: "White Pepper Premium",
    nameF: "Poivre Blanc Premium",
    category: "spices",
    price: 6000,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=premium%20white%20pepper%20in%20elegant%20glass%20spice%20jar%20with%20gold%20label%20on%20cream%20marble%20surface%2C%20gourmet%20spice%20gift%2C%20luxury%20food%20photography%2C%20beautiful%20presentation&width=400&height=400&seq=p6&orientation=squarish",
    description: "Finest quality white pepper sourced from Cameroon's best farms. A gourmet delight.",
    descriptionF: "Poivre blanc de la meilleure qualité des meilleures fermes du Cameroun.",
    badge: null,
    rating: 4.8,
    reviews: 38,
  },
  {
    id: 7,
    name: "Classic Literature Collection",
    nameF: "Collection Littérature Classique",
    category: "books",
    price: 14000,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=beautiful%20set%20of%20classic%20hardcover%20books%20with%20gold%20lettering%20stacked%20elegantly%20on%20cream%20background%20with%20dried%20flowers%20and%20satin%20ribbon%2C%20warm%20golden%20tones%2C%20premium%20literary%20gift%20collection%2C%20sophisticated%20and%20refined%2C%20luxury%20boutique%20presentation&width=400&height=400&seq=p7b&orientation=squarish",
    description: "A curated set of timeless classic literature in premium hardcover editions — a gift for every book lover.",
    descriptionF: "Une sélection de littérature classique intemporelle en éditions reliées premium — un cadeau pour tout amoureux des livres.",
    badge: "new",
    rating: 4.8,
    reviews: 63,
  },
  {
    id: 8,
    name: "Deluxe Surprise Gift Box",
    nameF: "Boîte Cadeau Surprise Deluxe",
    category: "giftboxes",
    price: 28000,
    originalPrice: 35000,
    image: "https://readdy.ai/api/search-image?query=luxurious%20surprise%20gift%20box%20tied%20with%20gold%20satin%20ribbon%20overflowing%20with%20flowers%20candles%20and%20gourmet%20treats%20on%20cream%20background%2C%20premium%20boutique%20gift%2C%20warm%20golden%20light%2C%20elegant%20and%20beautiful%2C%20festive%20presentation%2C%20luxury%20packaging&width=400&height=400&seq=p8b&orientation=squarish",
    description: "A beautifully curated surprise gift box filled with our most loved products — perfect for any occasion.",
    descriptionF: "Une magnifique boîte cadeau surprise remplie de nos produits les plus appréciés — parfaite pour toute occasion.",
    badge: "sale",
    rating: 5.0,
    reviews: 118,
  },
  {
    id: 9,
    name: "Sunflower Joy Bouquet",
    nameF: "Bouquet Joie de Tournesol",
    category: "flowers",
    price: 12000,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=bright%20cheerful%20sunflower%20bouquet%20with%20yellow%20ribbon%20on%20cream%20background%2C%20fresh%20flowers%20gift%20shop%2C%20warm%20golden%20light%2C%20beautiful%20floral%20arrangement%2C%20premium%20presentation&width=400&height=400&seq=p8&orientation=squarish",
    description: "Bright and cheerful sunflower bouquet to bring sunshine to any occasion.",
    descriptionF: "Bouquet de tournesols lumineux pour apporter du soleil à toute occasion.",
    badge: "popular",
    rating: 4.9,
    reviews: 92,
  },
  {
    id: 10,
    name: "Corporate Gift Box",
    nameF: "Boîte Cadeau Entreprise",
    category: "corporate",
    price: 35000,
    originalPrice: 42000,
    image: "https://readdy.ai/api/search-image?query=elegant%20corporate%20gift%20box%20with%20branded%20ribbon%20and%20premium%20contents%20on%20white%20background%2C%20professional%20business%20gift%20presentation%2C%20luxury%20packaging%2C%20gold%20and%20cream%20tones&width=400&height=400&seq=p10&orientation=squarish",
    description: "Professional corporate gift box with premium items, perfect for clients and employees.",
    descriptionF: "Boîte cadeau d'entreprise professionnelle avec articles premium pour clients et employés.",
    badge: "sale",
    rating: 4.8,
    reviews: 34,
  },
  {
    id: 11,
    name: "Black Pepper Gourmet",
    nameF: "Poivre Noir Gourmet",
    category: "spices",
    price: 5500,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=premium%20black%20pepper%20in%20elegant%20dark%20glass%20jar%20with%20gold%20label%20on%20cream%20marble%2C%20gourmet%20spice%20gift%2C%20luxury%20food%20photography%2C%20beautiful%20minimalist%20presentation&width=400&height=400&seq=p11&orientation=squarish",
    description: "Bold and aromatic black pepper from Cameroon's finest pepper farms.",
    descriptionF: "Poivre noir audacieux et aromatique des meilleures fermes de poivre du Cameroun.",
    badge: null,
    rating: 4.7,
    reviews: 29,
  },
  {
    id: 13,
    name: "Premium Red Wine",
    nameF: "Vin Rouge Premium",
    category: "wine",
    price: 18000,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=elegant%20premium%20red%20wine%20bottle%20with%20gold%20label%20on%20cream%20marble%20surface%20with%20wine%20glass%20and%20rose%20petals%2C%20luxury%20gift%20presentation%2C%20warm%20golden%20light%2C%20sophisticated%20and%20romantic%2C%20premium%20boutique&width=400&height=400&seq=p13&orientation=squarish",
    description: "A rich and velvety premium red wine, perfect for romantic evenings and special celebrations.",
    descriptionF: "Un vin rouge premium riche et velouté, parfait pour les soirées romantiques et les célébrations spéciales.",
    badge: "popular",
    rating: 4.9,
    reviews: 87,
  },
  {
    id: 14,
    name: "White Wine Elegance",
    nameF: "Élégance Vin Blanc",
    category: "wine",
    price: 16000,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=elegant%20white%20wine%20bottle%20with%20cream%20label%20on%20marble%20surface%20with%20wine%20glass%20and%20fresh%20flowers%2C%20luxury%20gift%20presentation%2C%20warm%20golden%20light%2C%20sophisticated%20and%20refined%2C%20premium%20boutique&width=400&height=400&seq=p14&orientation=squarish",
    description: "A crisp and refreshing white wine with floral notes, ideal for gifting and celebrations.",
    descriptionF: "Un vin blanc frais et rafraîchissant aux notes florales, idéal pour offrir et célébrer.",
    badge: "new",
    rating: 4.7,
    reviews: 52,
  },
  {
    id: 12,
    name: "Banana Jelly Delight",
    nameF: "Délice de Gelée Banane",
    category: "jellies",
    price: 4500,
    originalPrice: null,
    image: "https://readdy.ai/api/search-image?query=artisan%20banana%20jelly%20preserve%20in%20glass%20jar%20with%20yellow%20ribbon%20on%20cream%20background%2C%20homemade%20gourmet%20food%20gift%2C%20warm%20light%2C%20premium%20presentation%2C%20tropical%20fruit&width=400&height=400&seq=p12&orientation=squarish",
    description: "Creamy and sweet banana jelly made from ripe Cameroonian bananas.",
    descriptionF: "Gelée de banane crémeuse et sucrée faite à partir de bananes mûres du Cameroun.",
    badge: "new",
    rating: 4.6,
    reviews: 41,
  },
];

export const categories = [
  { id: "flowers", label: "Fresh Flowers", labelF: "Fleurs Fraîches", icon: "ri-plant-line", color: "from-pink-100 to-rose-200", image: "https://readdy.ai/api/search-image?query=beautiful%20fresh%20flowers%20arrangement%20roses%20peonies%20on%20soft%20cream%20background%2C%20luxury%20floral%20gift%20shop%2C%20elegant%20feminine%20aesthetic%2C%20warm%20golden%20light&width=400&height=500&seq=c1&orientation=portrait" },
  { id: "candles", label: "Scented Candles", labelF: "Bougies Parfumées", icon: "ri-fire-line", color: "from-amber-100 to-yellow-200", image: "https://readdy.ai/api/search-image?query=collection%20of%20elegant%20scented%20candles%20in%20glass%20jars%20with%20gold%20lids%20on%20cream%20marble%20surface%2C%20luxury%20home%20fragrance%2C%20warm%20ambient%20glow%2C%20premium%20gift%20boutique&width=400&height=500&seq=c2&orientation=portrait" },
  { id: "books", label: "Books & Journals", labelF: "Livres & Journaux", icon: "ri-book-open-line", color: "from-stone-100 to-amber-100", image: "https://readdy.ai/api/search-image?query=beautiful%20leather%20bound%20books%20and%20journals%20with%20dried%20flowers%20on%20cream%20background%2C%20elegant%20stationery%20gift%2C%20warm%20golden%20tones%2C%20premium%20literary%20gift%20presentation&width=400&height=500&seq=c3&orientation=portrait" },
  { id: "jellies", label: "Homemade Jellies", labelF: "Gelées Maison", icon: "ri-cup-line", color: "from-orange-100 to-red-100", image: "https://readdy.ai/api/search-image?query=collection%20of%20artisan%20homemade%20jelly%20jars%20in%20different%20flavors%20mango%20strawberry%20banana%20on%20cream%20background%2C%20gourmet%20food%20gift%2C%20warm%20light%2C%20premium%20presentation&width=400&height=500&seq=c4&orientation=portrait" },
  { id: "spices", label: "Gourmet Spices", labelF: "Épices Gourmandes", icon: "ri-leaf-line", color: "from-green-100 to-emerald-100", image: "https://readdy.ai/api/search-image?query=premium%20gourmet%20spice%20collection%20in%20elegant%20glass%20jars%20with%20gold%20labels%20on%20cream%20marble%2C%20luxury%20food%20gift%2C%20beautiful%20minimalist%20presentation%2C%20warm%20tones&width=400&height=500&seq=c5&orientation=portrait" },
  { id: "giftboxes", label: "Gift Boxes", labelF: "Boîtes Cadeaux", icon: "ri-gift-line", color: "from-rose-100 to-pink-200", image: "https://readdy.ai/api/search-image?query=luxury%20gift%20boxes%20with%20gold%20ribbon%20and%20bow%20on%20cream%20background%2C%20premium%20boutique%20gift%20packaging%2C%20elegant%20and%20beautiful%2C%20rose%20gold%20tones%2C%20romantic%20presentation&width=400&height=500&seq=c6&orientation=portrait" },
  { id: "corporate", label: "Corporate Gifts", labelF: "Cadeaux Entreprise", icon: "ri-briefcase-line", color: "from-slate-100 to-gray-200", image: "https://readdy.ai/api/search-image?query=elegant%20corporate%20gift%20set%20with%20branded%20packaging%20on%20white%20background%2C%20professional%20business%20gift%20presentation%2C%20luxury%20premium%20items%2C%20gold%20and%20cream%20tones&width=400&height=500&seq=c7&orientation=portrait" },
  { id: "seasonal", label: "Seasonal Gifts", labelF: "Cadeaux Saisonniers", icon: "ri-star-line", color: "from-red-100 to-rose-100", image: "https://readdy.ai/api/search-image?query=beautiful%20seasonal%20holiday%20gift%20collection%20with%20festive%20decorations%20on%20cream%20background%2C%20luxury%20gift%20boutique%2C%20warm%20golden%20light%2C%20elegant%20presentation&width=400&height=500&seq=c8&orientation=portrait" },
  { id: "wine", label: "Fine Wines", labelF: "Vins Fins", icon: "ri-goblet-line", color: "from-rose-200 to-red-200", image: "https://readdy.ai/api/search-image?query=elegant%20wine%20bottles%20collection%20with%20glasses%20on%20cream%20marble%20surface%2C%20luxury%20wine%20gift%20selection%2C%20warm%20golden%20light%2C%20sophisticated%20and%20premium%20boutique%20presentation&width=400&height=500&seq=c9&orientation=portrait" },
];

export const testimonials = [
  {
    id: 1,
    name: "Amina Bello",
    role: "Regular Customer",
    roleF: "Cliente Régulière",
    text: "Creative Hub transformed my anniversary into something magical. The custom gift box was absolutely stunning — my husband was speechless. The quality and attention to detail is unmatched in Douala!",
    textF: "Creative Hub a transformé mon anniversaire en quelque chose de magique. La boîte cadeau personnalisée était absolument magnifique — mon mari était sans voix. La qualité et l'attention aux détails sont incomparables à Douala!",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=elegant%20african%20woman%20smiling%20portrait%20on%20soft%20cream%20background%2C%20warm%20natural%20light%2C%20professional%20photo%2C%20beautiful%20and%20confident&width=100&height=100&seq=t1&orientation=squarish",
  },
  {
    id: 2,
    name: "Jean-Pierre Mbarga",
    role: "Corporate Client",
    roleF: "Client Entreprise",
    text: "We ordered 50 corporate gift boxes for our year-end event. Creative Hub delivered on time, beautifully packaged, and our clients were impressed. Highly recommend for corporate gifting!",
    textF: "Nous avons commandé 50 boîtes cadeaux d'entreprise pour notre événement de fin d'année. Creative Hub a livré à temps, magnifiquement emballé, et nos clients étaient impressionnés.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=professional%20african%20businessman%20smiling%20portrait%20on%20soft%20cream%20background%2C%20warm%20natural%20light%2C%20confident%20and%20elegant&width=100&height=100&seq=t2&orientation=squarish",
  },
  {
    id: 3,
    name: "Sophie Nkemdirim",
    role: "Birthday Shopper",
    roleF: "Acheteuse Anniversaire",
    text: "The flower bouquet I ordered for my mother's birthday was breathtaking. Fresh, fragrant, and beautifully arranged. She cried happy tears! Creative Hub is my go-to gift shop forever.",
    textF: "Le bouquet de fleurs que j'ai commandé pour l'anniversaire de ma mère était époustouflant. Frais, parfumé et magnifiquement arrangé. Elle a pleuré de joie!",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=beautiful%20african%20woman%20smiling%20portrait%20on%20soft%20cream%20background%2C%20warm%20natural%20light%2C%20joyful%20and%20elegant&width=100&height=100&seq=t3&orientation=squarish",
  },
  {
    id: 4,
    name: "David Tchamba",
    role: "Valentine's Customer",
    roleF: "Client Saint-Valentin",
    text: "I surprised my girlfriend with a romantic hamper from Creative Hub — roses, candles, and strawberry jelly. She absolutely loved it! The packaging was so luxurious and elegant.",
    textF: "J'ai surpris ma petite amie avec un panier romantique de Creative Hub — roses, bougies et gelée de fraise. Elle a adoré! L'emballage était si luxueux et élégant.",
    rating: 5,
    image: "https://readdy.ai/api/search-image?query=handsome%20african%20man%20smiling%20portrait%20on%20soft%20cream%20background%2C%20warm%20natural%20light%2C%20charming%20and%20confident&width=100&height=100&seq=t4&orientation=squarish",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: "Top 10 Gift Ideas for Mother's Day in Cameroon",
    titleF: "Top 10 Idées Cadeaux pour la Fête des Mères au Cameroun",
    excerpt: "Celebrate the most important woman in your life with these thoughtfully curated gift ideas that will make her feel truly special.",
    excerptF: "Célébrez la femme la plus importante de votre vie avec ces idées cadeaux soigneusement sélectionnées.",
    category: "Gift Ideas",
    categoryF: "Idées Cadeaux",
    readTime: 5,
    date: "May 5, 2026",
    dateF: "5 Mai 2026",
    image: "https://readdy.ai/api/search-image?query=beautiful%20mother%20receiving%20flower%20bouquet%20gift%20from%20daughter%2C%20warm%20emotional%20moment%2C%20soft%20cream%20and%20pink%20tones%2C%20elegant%20lifestyle%20photography%2C%20premium%20gift%20boutique&width=600&height=400&seq=b1&orientation=landscape",
  },
  {
    id: 2,
    title: "How to Build the Perfect Custom Gift Hamper",
    titleF: "Comment Créer le Panier Cadeau Personnalisé Parfait",
    excerpt: "A step-by-step guide to creating a personalized gift hamper that will leave a lasting impression on your loved ones.",
    excerptF: "Un guide étape par étape pour créer un panier cadeau personnalisé qui laissera une impression durable.",
    category: "Tips & Tricks",
    categoryF: "Conseils & Astuces",
    readTime: 7,
    date: "April 20, 2026",
    dateF: "20 Avril 2026",
    image: "https://readdy.ai/api/search-image?query=elegant%20gift%20hamper%20being%20assembled%20with%20flowers%20candles%20and%20gourmet%20items%20on%20cream%20background%2C%20luxury%20gift%20boutique%2C%20warm%20golden%20light%2C%20beautiful%20presentation&width=600&height=400&seq=b2&orientation=landscape",
  },
  {
    id: 3,
    title: "The Art of Gifting: Why Presentation Matters",
    titleF: "L'Art d'Offrir: Pourquoi la Présentation Compte",
    excerpt: "Discover how beautiful packaging and thoughtful presentation can transform an ordinary gift into an extraordinary experience.",
    excerptF: "Découvrez comment un beau packaging peut transformer un cadeau ordinaire en une expérience extraordinaire.",
    category: "Inspiration",
    categoryF: "Inspiration",
    readTime: 4,
    date: "April 10, 2026",
    dateF: "10 Avril 2026",
    image: "https://readdy.ai/api/search-image?query=luxury%20gift%20wrapping%20and%20packaging%20process%20with%20gold%20ribbon%20and%20cream%20paper%20on%20elegant%20table%2C%20premium%20boutique%20aesthetic%2C%20warm%20light%2C%20beautiful%20and%20artistic&width=600&height=400&seq=b3&orientation=landscape",
  },
  {
    id: 4,
    title: "Corporate Gifting: Building Relationships Through Thoughtful Gifts",
    titleF: "Cadeaux d'Entreprise: Construire des Relations par des Cadeaux Réfléchis",
    excerpt: "Learn how strategic corporate gifting can strengthen business relationships and leave a lasting positive impression.",
    excerptF: "Apprenez comment les cadeaux d'entreprise stratégiques peuvent renforcer les relations commerciales.",
    category: "Corporate",
    categoryF: "Entreprise",
    readTime: 6,
    date: "March 28, 2026",
    dateF: "28 Mars 2026",
    image: "https://readdy.ai/api/search-image?query=professional%20corporate%20gift%20exchange%20in%20elegant%20office%20setting%2C%20business%20people%20exchanging%20premium%20gift%20boxes%2C%20warm%20professional%20atmosphere%2C%20luxury%20corporate%20gifting&width=600&height=400&seq=b4&orientation=landscape",
  },
  {
    id: 5,
    title: "Scented Candles: The Perfect Gift for Every Occasion",
    titleF: "Bougies Parfumées: Le Cadeau Parfait pour Chaque Occasion",
    excerpt: "From birthdays to housewarmings, discover why scented candles are the ultimate versatile gift that everyone loves.",
    excerptF: "Des anniversaires aux pendaisons de crémaillère, découvrez pourquoi les bougies parfumées sont le cadeau ultime.",
    category: "Products",
    categoryF: "Produits",
    readTime: 3,
    date: "March 15, 2026",
    dateF: "15 Mars 2026",
    image: "https://readdy.ai/api/search-image?query=collection%20of%20beautiful%20scented%20candles%20glowing%20in%20dim%20romantic%20light%20on%20cream%20marble%20surface%2C%20luxury%20home%20fragrance%2C%20warm%20amber%20glow%2C%20elegant%20lifestyle%20photography&width=600&height=400&seq=b5&orientation=landscape",
  },
  {
    id: 6,
    title: "Homemade Jellies: A Taste of Cameroon in Every Jar",
    titleF: "Gelées Maison: Un Goût du Cameroun dans Chaque Pot",
    excerpt: "Explore the story behind our artisan jellies and why they make the most unique and delicious gifts from Cameroon.",
    excerptF: "Explorez l'histoire derrière nos gelées artisanales et pourquoi elles font les cadeaux les plus uniques du Cameroun.",
    category: "Products",
    categoryF: "Produits",
    readTime: 4,
    date: "March 1, 2026",
    dateF: "1 Mars 2026",
    image: "https://readdy.ai/api/search-image?query=artisan%20jelly%20jars%20collection%20with%20tropical%20fruits%20mango%20strawberry%20banana%20on%20rustic%20wooden%20table%2C%20warm%20natural%20light%2C%20gourmet%20food%20photography%2C%20Cameroon%20artisan%20food&width=600&height=400&seq=b6&orientation=landscape",
  },
];

export const occasions = [
  {
    id: "birthdays",
    label: "Birthdays",
    labelF: "Anniversaires",
    icon: "ri-cake-line",
    color: "from-pink-400 to-rose-500",
    image: "https://readdy.ai/api/search-image?query=beautiful%20birthday%20gift%20arrangement%20with%20flowers%20candles%20and%20cake%20on%20cream%20background%2C%20warm%20celebration%2C%20elegant%20premium%20gift%20boutique%2C%20pink%20and%20gold%20tones&width=500&height=600&seq=o1&orientation=portrait",
    desc: "Make their day unforgettable with our curated birthday collections.",
    descF: "Rendez leur journée inoubliable avec nos collections d'anniversaire.",
  },
  {
    id: "weddings",
    label: "Weddings",
    labelF: "Mariages",
    icon: "ri-heart-line",
    color: "from-rose-400 to-pink-500",
    image: "https://readdy.ai/api/search-image?query=elegant%20wedding%20gift%20arrangement%20with%20white%20flowers%20and%20gold%20ribbon%20on%20cream%20background%2C%20luxury%20bridal%20gift%2C%20romantic%20and%20beautiful%2C%20premium%20boutique%20presentation&width=500&height=600&seq=o2&orientation=portrait",
    desc: "Celebrate love with our romantic and luxurious wedding gift collections.",
    descF: "Célébrez l'amour avec nos collections de cadeaux de mariage romantiques.",
  },
  {
    id: "anniversaries",
    label: "Anniversaries",
    labelF: "Anniversaires de Couple",
    icon: "ri-star-smile-line",
    color: "from-amber-400 to-orange-500",
    image: "https://readdy.ai/api/search-image?query=romantic%20anniversary%20gift%20with%20red%20roses%20candles%20and%20champagne%20on%20cream%20background%2C%20luxury%20couple%20gift%2C%20warm%20golden%20light%2C%20elegant%20premium%20presentation&width=500&height=600&seq=o3&orientation=portrait",
    desc: "Cherish every milestone with gifts that speak from the heart.",
    descF: "Chérissez chaque étape avec des cadeaux qui parlent du cœur.",
  },
  {
    id: "valentine",
    label: "Valentine's Day",
    labelF: "Saint-Valentin",
    icon: "ri-hearts-line",
    color: "from-red-400 to-rose-600",
    image: "https://readdy.ai/api/search-image?query=romantic%20valentines%20day%20gift%20with%20red%20roses%20heart%20shaped%20box%20chocolates%20and%20candles%20on%20cream%20background%2C%20luxury%20love%20gift%2C%20warm%20romantic%20light%2C%20premium%20boutique&width=500&height=600&seq=o4&orientation=portrait",
    desc: "Express your deepest love with our Valentine's Day special collections.",
    descF: "Exprimez votre amour le plus profond avec nos collections spéciales Saint-Valentin.",
  },
  {
    id: "mothers",
    label: "Mother's Day",
    labelF: "Fête des Mères",
    icon: "ri-user-heart-line",
    color: "from-purple-400 to-pink-500",
    image: "https://readdy.ai/api/search-image?query=beautiful%20mothers%20day%20gift%20with%20pink%20flowers%20candles%20and%20journal%20on%20cream%20background%2C%20warm%20celebration%2C%20elegant%20premium%20gift%20boutique%2C%20soft%20pink%20tones&width=500&height=600&seq=o5&orientation=portrait",
    desc: "Honor the most important woman in your life with our Mother's Day gifts.",
    descF: "Honorez la femme la plus importante de votre vie avec nos cadeaux Fête des Mères.",
  },
  {
    id: "corporate",
    label: "Corporate Events",
    labelF: "Événements d'Entreprise",
    icon: "ri-building-line",
    color: "from-slate-500 to-gray-600",
    image: "https://readdy.ai/api/search-image?query=elegant%20corporate%20event%20gift%20boxes%20with%20branded%20packaging%20on%20white%20background%2C%20professional%20business%20gift%20presentation%2C%20luxury%20premium%20items%2C%20gold%20and%20cream%20tones&width=500&height=600&seq=o6&orientation=portrait",
    desc: "Impress clients and reward employees with our premium corporate gifts.",
    descF: "Impressionnez les clients et récompensez les employés avec nos cadeaux d'entreprise.",
  },
  {
    id: "christmas",
    label: "Christmas",
    labelF: "Noël",
    icon: "ri-gift-2-line",
    color: "from-green-500 to-emerald-600",
    image: "https://readdy.ai/api/search-image?query=beautiful%20christmas%20gift%20arrangement%20with%20festive%20decorations%20red%20ribbon%20and%20gold%20accents%20on%20cream%20background%2C%20luxury%20holiday%20gift%20boutique%2C%20warm%20festive%20light&width=500&height=600&seq=o7&orientation=portrait",
    desc: "Spread joy and warmth with our festive Christmas gift collections.",
    descF: "Répandez la joie et la chaleur avec nos collections de cadeaux de Noël.",
  },
];